import React, { useState, useEffect } from 'react';

const YoutubePopup = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleOpen = () => setIsOpen(true);
    window.addEventListener('open-campus-video', handleOpen);
    return () => window.removeEventListener('open-campus-video', handleOpen);
  }, []);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[9999] bg-black/80 flex items-center justify-center p-4">
      <div className="relative w-full max-w-4xl bg-black rounded-lg overflow-hidden shadow-2xl">
        <button onClick={() => setIsOpen(false)} className="absolute -top-10 right-0 md:top-2 md:right-2 text-white bg-black/50 hover:bg-black/80 rounded-full w-10 h-10 flex items-center justify-center z-10 transition-colors">
          <i className="fas fa-times text-xl"></i>
        </button>
        <div className="relative pt-[56.25%]">
          <iframe 
            className="absolute inset-0 w-full h-full"
            src="https://www.youtube.com/embed/jPdBTDbS25s?start=17&autoplay=1" 
            title="Campus Visit Video" 
            frameBorder="0" 
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default YoutubePopup;
